import { request } from './repository';

const url = 'users/';

const usersRepository = {
  fetchAllUsers(params) {
    return request.get(url, params);
  },
  fetchUser(id) {
    return request.get(url + id);
  },
}

export default usersRepository;
